export default {
  content_type_icons: {
    'default': 'ion-md-cube',
    'movie': 'ion-md-videocam',
    'tvshow': 'ion-md-tv',
    'book': 'ion-md-book',
    'game': 'ion-logo-game-controller-b',
    'place': 'ion-md-pin',
    'boardgame': 'fa fa-chess-pawn'
  },
  content_type_names: {
    'default': 'Anything',
    'movie': 'Movies',
    'tvshow': 'TV Shows',
    'book': 'Books',
    'game': 'Video Games',
    'place': 'Places',
    'boardgame': 'Board Games'
  },
  rich_content_types: ['movie', 'tvshow', 'book', 'boardgame', 'game']
}